import React from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './glmap.css';


mapboxgl.accessToken = 'pk.eyJ1IjoiZGlhc2YiLCJhIjoiY2pqc243cW9wNDN6NTNxcm1jYW1jajY2NyJ9.2C0deXZ03NJyH2f51ui4Jg';



let Map = class Map extends React.Component {
  constructor(props){
    super(props);
    this.state={map:undefined,popup:undefined,colour:[0,'black',1,'red'],exHeight:[0,0,1,2000]}
  }

  
  componentDidUpdate() {
    if (this.map){
      this.setVisibility();
      this.setFill();  
    }
  }

  componentWillUpdate(nextProps, nextState) {
    // console.log(nextProps,this.props)
    if ((this.moving!==undefined)&&(this.moving)){
      return;
    }
    if (nextProps.boundsCallback!==undefined){
      nextProps.boundsCallback(undefined);
    }
    return((this.props.kind!==nextProps.kind)||
        (this.props.field!==nextProps.field)||
        (this.props.colour!==nextProps.colour));
  }

  setVisibility(){
    if ((this.props.kind!==undefined)&&(this.props.kind==='3d')){
      this.map.setLayoutProperty('LA3D','visibility','visible');
      this.map.setLayoutProperty('LA','visibility','none');
      this.map.setPitch(45);
    }else{
      this.map.setLayoutProperty('LA','visibility','visible');
      this.map.setLayoutProperty('LA3D','visibility','none');
      this.map.setPitch(0);
    }
  }
  setFill(){
    this.map.setPaintProperty('LA', 'fill-color',[
      'interpolate', ['linear'], ['get', this.props.field],
      ...this.state.colour
    ]);
  this.map.setPaintProperty('LA3D','fill-extrusion-color',[
      'interpolate', ['linear'], ['get', this.props.field],
      ...this.state.colour
    ]);
    this.map.setPaintProperty('LA3D','fill-extrusion-height',[
      'interpolate', ['linear'], ['get', this.props.field],
      ...this.state.exHeight
    ]);

  }

  componentDidMount() {
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/light-v9',
      center: [-118.33, 34.0150516],
      zoom:8,
    });

    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
    });

    //Use this callback to syncronize views across different maps
    let BoundsChange=(d)=>{
      if (d.originalEvent!==undefined){//&&(this.moving===false))  
        if (this.props.boundsCallback!==undefined){
          this.props.boundsCallback(this.map.getBounds());
        }
      }
    }

    this.map.on('dragend', BoundsChange);
    this.map.on('zoomend', BoundsChange);    
    this.map.on('movestart',()=>{this.moving=true;});
    this.map.on('moveend',()=>{this.moving=false;});
    this.map.on('click',(e)=>{
      // this.map.flyTo({center:[e.lngLat.lng,e.lngLat.lat]});
      //this function also works if you load the layer from mapbox servers
      var features = this.map.queryRenderedFeatures(e.point, { layers: ['LA'] });
      if (features.length>0){
        if (this.props.clbClick!==undefined){
          //pass the properties of the geometry clicked back to the "above"
          //object. Lazy way of not using react-redux. But also leaves this object more flexible
          this.props.clbClick(features[0].properties);
        }
      }
    });


    this.map.on('load', () => {
      if (this.props.colour!==undefined){
        this.setState({colour:this.props.colour});
      }
      if (this.props.exHeight!==undefined){
        this.setState({exHeight:this.props.exHeight});
      }

      if (this.props.geojson!==undefined){
          this.map.addSource('gj', {
            type: 'geojson',
            data: this.props.geojson,
          });

          this.map.addLayer({
            id: 'LA',
            type: 'fill',
            source: 'gj', 
            layout: {visibility:'none'},
            //https://www.mapbox.com/mapbox-gl-js/style-spec/#layers-fill
            paint: {
              "fill-outline-color":'gray',
              'fill-opacity' : 0.9,
            }            
          }, 'country-label-lg');   
          
    
          this.map.addLayer({
            id: 'LA3D',
            type: 'fill-extrusion',
            source: 'gj', 
            layout: {visibility:'none'},
            //https://www.mapbox.com/mapbox-gl-js/style-spec/#layers-fill
            paint: {
              'fill-extrusion-opacity' : 0.9,
            }            
          }, 'country-label-lg');   
          this.setFill()
          this.setVisibility(); 

          this.map.on('mousemove','LA', (e)=>{
            this.popup.remove();
            // var coordinates = e.features[0].geometry.coordinates.slice();
            // console.log(e)
            let p=e.features[0].properties;
            var description = p.City+"("+p.Zip+") - "+this.props.field+": " +p[this.props.field];
            this.popup.setLngLat(e.lngLat).setHTML(description).addTo(this.map);
            // this.map.setFeatureState({source:'gj', id:e.features[0].id},{hover:true});
          });
          this.map.on('mouseleave', 'LA', ()=>{
            this.popup.remove();
            // this.map.setFeatureState({source:'LA', id:e.features[0].id},{hover:false});
          });

        this.setState({'map':this.map});
        }
    });
  }

  render() {
    // console.log(this.props);
    return (
      <div ref={el => this.mapContainer = el} 
      className={(this.props.className!==undefined)?this.props.className:"absolute top right left bottom"}
      />
    );
  }
}


export default Map;
